






























  

import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import GiganautVueDialog from '@/components/Shared/GiganautVueDialog';
import AgencyUserDto from '@/models/AgencyUsers/AgencyUserDto';
import { AppModule } from '@/store/modules/app';
import CreateConversationParticipantRequest from '@/models/Conversations/CreateConversationParticipantRequest';
import { BookingDetailsModule } from '@/store/modules/bookingDetails';
import ConversationParticipantDto from '@/models/Conversations/ConversationParticipantDto';

@Component({
    name: 'BookingCreateConversationParticipant'
})
export default class extends GiganautVueDialog {
 
    @Prop({required: true})
    agencyUsers: AgencyUserDto[];

    get agencyUsersFiltered() {
      if (BookingDetailsModule.conversation && BookingDetailsModule.conversation.participantFirebaseUserIds) {
        return this.agencyUsers.filter(function(agencyUser){
          if (BookingDetailsModule.conversation.participantFirebaseUserIds.includes(agencyUser.userId)) {
            return false;
          } else {
          return true;
          }
        });
      }
      return this.agencyUsers;
    }

    async createConversationParticipant(agencyUser: AgencyUserDto) {
        const request = new CreateConversationParticipantRequest();
        request.entityId = agencyUser.id;
        request.entityType = this.EntityType.AgencyUser
        await BookingDetailsModule.createConversationParticipant(request);
    }

    getUserAvatarUrl(user: AgencyUserDto) {
        return AppModule.currentAgencyContext.storageSharedBaseUrl + "/avatars/2/" + user.id + "/resized-100/" + user.avatar;
    }
}
